// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"5cff09d2","334":"fbe38074","787":"c84e592b","824":"b344f266"}[chunkId] + ".chunk.js";
};